import React from 'react';
import Box, { BoxProps } from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import colors from 'src/utils/colors';

type ScrollableContainerProps = BoxProps & {
  scrollbarWidth?: string;
  thumbColor?: string;
};

const ScrollableBox = (props: ScrollableContainerProps) => <Box {...props} />;

/**
 * A container for scrollable content that
 * shows a scrollbar. For some reason, by default
 * the scrollbar is hidden so this component
 * is needed to show it.
 */
export default styled(ScrollableBox)(
  ({ scrollbarWidth = '3px', thumbColor = colors.grey }: ScrollableContainerProps) => ({
    overflowY: 'scroll',
    '&::-webkit-scrollbar': {
      width: scrollbarWidth,
      height: '12px'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: thumbColor,
      borderRadius: '3px',
      height: '12px'
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'transparent'
    }
  })
);
